import React from 'react';
import './index.less';
import {Loading} from 'acud';

export interface OverviewStatItem {
  label: string;
  icon: React.ReactNode;
  value: number | string | null;
  unit?: string;
  onClick?: () => void;
  loading?: boolean;
  link?: string;
}

export interface OverviewStatsProps {
  title?: string;
  items: OverviewStatItem[];
  className?: string;
}

const OverviewStats: React.FC<OverviewStatsProps> = ({title, items, className}) => {
    const handleClick = (item: OverviewStatItem) => {
        if (item.link) {
            window.open(item.link, '_blank', 'noopener,noreferrer');
        }
        else if (item.onClick) {
            item.onClick();
        }
    };

    return (
        <div className={`overview-stats-root${className ? ' ' + className : ''}`}>
            {title && <div className="overview-stats-title">{title}</div>}
            <div className="overview-stats-list">
                {items.map(item => (
                    <div
                        key={item.label}
                        className="overview-stats-item"
                        onClick={() => handleClick(item)}
                    >
                        <div className="overview-stats-header">
                            <span className="overview-stats-icon">{item.icon}</span>
                            <span className="overview-stats-label">{item.label}</span>
                        </div>
                        <div className="overview-stats-value-unit">
                            {item.loading ? (
                                <Loading />
                            ) : (
                                <>
                                    <span className="overview-stats-value">{item.value}</span>
                                    {item.unit && <span className="overview-stats-unit">{item.unit}</span>}
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OverviewStats;